import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent } from '../../components/button/button.component';

@Component({
  selector: 'app-delete-customization',
  templateUrl: './delete-customization.component.html',
  styleUrls: ['./delete-customization.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ButtonComponent,
  ],
})
export class DeleteCustomizationComponent {
  private readonly activeModal = inject(NgbActiveModal);

  continue() {
    this.activeModal.close(false);
  }
  cancel() {
    this.activeModal.close(true);
  }

}
